// Modal de criar/editar Tipo de Peça — só nome + categoria (ADR-0006: preço
// mora na Tabela de Preços). Compartilhado pela tela de Tipos de Peça e pelo
// "+ Novo tipo de peça" da Tabela de Preços.

import { newId } from "../../domain/ids.ts";
import type { TipoPeca } from "../../domain/snapshot.ts";
import type { Store } from "../store.ts";
import { el } from "../ui.ts";
import { abrirFormModal, campo, campoObrigatorio, inputTexto } from "./_cadastro.ts";
import { categoriaSelect } from "./_categoria-select.ts";

/**
 * Abre o modal. `aoSalvar` recebe o id do Tipo criado/editado (útil para quem
 * quer, por exemplo, focar a linha nova na Tabela de Preços).
 */
export function abrirFormTipoPeca(
  store: Store,
  atual: TipoPeca | null,
  aoSalvar?: (tipoId: string) => void,
): void {
  const nome = inputTexto("Nome do tipo de peça", atual?.nome ?? "");
  const categoria = categoriaSelect(store, atual?.categoriaId ?? "");

  abrirFormModal({
    titulo: atual ? `Editar ${atual.nome}` : "Novo Tipo de Peça",
    rotuloSalvar: atual ? "Salvar" : "Criar Tipo de Peça",
    campos: () =>
      el("div", {}, campoObrigatorio("Nome", nome), campo("Categoria", categoria.element)),
    salvar: (aoErro) => {
      const dados = { nome: nome.value, categoriaId: categoria.value() };
      // Id gerado aqui (ADR-0003): a tela já sabe o que criou, sem caçar no
      // Snapshot depois de o comando voltar.
      const id = atual?.id ?? newId();
      const cmd = atual
        ? ({ tipo: "editar", id, dados } as const)
        : ({ tipo: "criar", id, dados } as const);
      return store
        .executar({ agregado: "tipoPeca", cmd }, undefined, aoErro)
        .then(() => aoSalvar?.(id));
    },
  });
}
